import type { ConnectedProjectDto, ProjectOverviewItemDto } from "@/api/types";

/**
 * If an empty filter array is passed, all projects match. Otherwise we only match if the project's value is included in the filter array.
 */
export function filterProjectsByFilters<T extends ProjectOverviewItemDto | ConnectedProjectDto>(
  projects: T[],
  filters?: {
    owner?: string[];
    maintenance?: string[];
    city?: string[];
    projectIds?: string[];
    search?: string;
  },
): T[] {
  const search = filters?.search?.toLowerCase().trim() || "";

  if (
    !projects.length ||
    (!filters?.maintenance?.length &&
      !filters?.city?.length &&
      !filters?.owner?.length &&
      !filters?.projectIds?.length &&
      !search)
  ) {
    return projects;
  }

  return projects.filter((project) => {
    const isOwnerMatching = !filters?.owner?.length || filters?.owner.includes(project.owner);
    if (!isOwnerMatching) {
      return false;
    }

    const isMaintenanceMatching = !filters?.maintenance?.length || filters?.maintenance.includes(project.maintenance);
    if (!isMaintenanceMatching) {
      return false;
    }

    const isCityMatching = !filters?.city?.length || filters?.city.includes(project.city);
    if (!isCityMatching) {
      return false;
    }

    const isProjectIdMatching = !filters?.projectIds?.length || filters?.projectIds.includes(project.id);
    if (!isProjectIdMatching) {
      return false;
    }

    const isNameOrCityMatching =
      !search || project.name.toLowerCase().includes(search) || project.city.toLowerCase().includes(search);
    if (!isNameOrCityMatching) {
      return false;
    }

    return true;
  });
}
